import { createStore } from 'satcheljs';
export default createStore('focusedInboxOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map